$(function() {
    // cookie consent and analytics

    if (getCookie("cookie_consent") === "true") {
        enableAnalytics();
    } else {
        $("#cookieConsentBox").show();
    }

    $("#cookieConsentButton").on("click", function() {
        // set persistent cookie for 1 year
        document.cookie = "cookie_consent=true; Path=/; Max-Age=31536000; Secure; SameSite=Lax";
        // close box
        $("#cookieConsentBox").hide();
        // execute 3rd parties
        enableAnalytics();
    });
});

function getCookie(name) {
    if (!document.cookie) {
        return null;
    }

    // cookie key/value pairs may be separated by semicolon or semicolon space
    // there may be whitespace at the beginning and end of cookie string
    const cookies = document.cookie.split(";");

    const prefix = name + '=';

    const pair = cookies.find(element => element.trim().startsWith(prefix));
    if (!pair) {
        return null;
    }

    // strip off key and '='
    const value = pair.trim().substring(prefix.length);

    return value;
}

function enableAnalytics() {
    // Google Analytics
    gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
		'ad_personalization': 'granted',
        'analytics_storage': 'granted'
    });
    // Facebook Pixel
    fbq('consent', 'grant');
}
